import React from 'react';

const RootBottomSection = ({ children }) => <div data-ppuc-id="RootBottomSection">{children}</div>;

RootBottomSection.displayName = 'Root.BottomSection';

export default RootBottomSection;
